import { render, staticRenderFns } from "./confiGroupMain.vue?vue&type=template&id=d3c358a2&"
import script from "./confiGroupMain.vue?vue&type=script&lang=js&"
export * from "./confiGroupMain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports